// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"bcl_a bhr_wl","LoadingPlaceholder":"bcl_b bhr_h","loading-placeholder":"bcl_c"};